import { Component, Input, OnInit } from '@angular/core';
import { Articles } from "../../../../models/leads/leads.model";
import { LeadHelper } from '../../../../helper/lead.helper';

@Component({
  selector: 'fi-brochure-sample',
  templateUrl: './brochure-sample.component.html',
  styleUrls: ['./brochure-sample.component.scss'],
  standalone: false,
})
export class BrochureSampleComponent implements OnInit {

  @Input() articles: Articles[];
  @Input() LeadTypeId: number;
  muster = LeadHelper.LEAD_TYPE_MUSTER;
  brochure = LeadHelper.LEAD_TYPE_BROCHURE;
  ausschreibungstexte = LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE;
  cadDaten = LeadHelper.LEAD_TYPE_CAD_DATEN;

  constructor() {
  }

  ngOnInit(): void {
  }

}
